import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const AlertConfirmModal = ({ modalTitle = "", modalBody = "", show, setShow, isConfirm = false, setConfirm, useFunction }) => {

    function showBody(text) {
        return { __html: text };
    }

    return (
        <Modal size="md" className="alert-confirm-modal" centered show={show} onHide={() => setShow(false)}>
            {modalTitle &&
                <Modal.Header closeButton>
                    <Modal.Title>{modalTitle}</Modal.Title>
                </Modal.Header>
            }
            <Modal.Body>
                {
                    React.isValidElement(modalBody)
                        ? modalBody
                        : <div dangerouslySetInnerHTML={showBody(modalBody)} />
                }
                <div className="alertconfirm-btns">
                    {isConfirm ?
                        <>
                            <Button
                                onClick={() => { useFunction(); setShow(false); }}
                                variant="primary"
                                style={{ width: '90px' }}
                                className="text-center"
                            >Ok</Button>
                            <Button
                                onClick={() => setShow(false)}
                                variant="secondary"
                                style={{ width: '90px' }}
                                className="text-center"
                            >Cancel</Button>
                        </>
                        :
                        <>
                            <Button onClick={() => setShow(false)} variant="primary">Ok</Button>
                        </>
                    }
                </div>
            </Modal.Body>
        </Modal>
    );
};
export default AlertConfirmModal;
